import { Box, CssBaseline } from "@mui/material";
import React from "react";
import GeneralAdminSidebar from "../../../common/GeneralAdminSidebar";
import Header from "../../../common/Header";
import MainLayout from "../../../common/MainLayout";
import Sidebar from "../../../common/Sidebar";

const GALogin = () => {
  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <Header mainTitle={"Logout"} />
      <GeneralAdminSidebar />
      <MainLayout>
        <h1>Logout</h1>
      </MainLayout>
    </Box>
  );
};

export default GALogin;
